export interface TrialOffer {
  enabled?: boolean;
  startedAt?: number | null;
  expiresAt?: number | null;
  durationMinutes?: number;
  reminderLeadMinutes?: number;
  tokens?: number;
  durationDays?: number;
  unlockAmountCents?: number;
  unlockCurrency?: string;
  reason?: string;
}

export const getTrialOfferRemainingMs = (trialOffer?: TrialOffer | null): number => {
  if (!trialOffer?.enabled || typeof trialOffer.expiresAt !== 'number') {
    return 0;
  }

  return Math.max(0, trialOffer.expiresAt - Date.now());
};

export const formatTrialOfferCountdown = (remainingMs: number): string => {
  const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

export const formatTrialUnlockPrice = (
  amountCents?: number,
  currency = 'usd',
): string => {
  const cents = typeof amountCents === 'number' && Number.isFinite(amountCents)
    ? amountCents
    : 200;
  const amount = cents / 100;

  if (currency.toLowerCase() === 'usd') {
    return cents % 100 === 0 ? `$${amount.toFixed(0)}` : `$${amount.toFixed(2)}`;
  }

  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currency.toUpperCase(),
  }).format(amount);
};
